export default function (state) {
    let date = new Date();
    state.dateType = 1;
    state.dates = [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ];
    state.CurrencyId = [];
    state.PayStates = [];
    state.PaymentTypeIds = [];
    state.CashList = [];
    state.PaymentAccountList = [];
    state.ManagerList = [];
    state.DepartmentList = [];
    state.InvoiceSumFrom = 0;
    state.InvoiceSumTo = 0;
    state.PaymentOperationId = '';
    state.CategoryId = '';
    state.ContragentId = '';
    state.ContragentName = '';
    state.ContragentSearchTypeId = '';
    state.KindOfPayId = '';
    state.AccountNumber = '';
    state.AgreementCode = '';
    state.OnlyOverdue = false;
}